// extracted by mini-css-extract-plugin
export default {"notificationsTimes":"styles_notifications-times__i+DZK","notificationsTimes__item":"styles_notifications-times__item__EaNVL"};